import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CommonBanner, ContactForm, Footer, Header } from "../../components";
import { get_public_branches } from "../../apis/Branches";
import { C, FONT, container } from "../../constants/mq";

// Contact us. One clear form plus how to reach us, with the campus list
// pulled from real branch data rather than hardcoded into the page.

const HEAD_OFFICE = {
  address: "Unit 121, 14 Lexington Drive, Bella Vista NSW 2153",
  phones: ["+61 2 8883 0055", "+61 2 8883 2555"],
  hours: "Monday to Friday, 9:00am – 5:30pm",
};

const s = {
  body: { background: C.sand, padding: "56px 0 80px", fontFamily: FONT },
  container,
  layout: {
    display: "grid",
    gridTemplateColumns: "1.5fr 1fr",
    gap: 28,
    alignItems: "start",
  },
  side: { display: "flex", flexDirection: "column", gap: 16 },
  // white card (.mq-card) on the sand page
  panel: { padding: "24px 22px" },
  panelTitle: {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    color: C.red,
    margin: "0 0 14px",
  },
  line: { fontSize: 14.5, lineHeight: 1.7, color: C.body, margin: "0 0 10px" },
  strong: { color: C.ink, fontWeight: 600 },
  link: { color: C.ink, textDecoration: "none", fontWeight: 600 },
  campus: {
    borderTop: `1px solid ${C.line}`,
    padding: "14px 0 0",
    marginTop: 14,
  },
  campusName: { fontSize: 15, fontWeight: 700, color: C.ink, margin: "0 0 4px" },
  campusMeta: { fontSize: 13.5, lineHeight: 1.6, color: C.muted, margin: 0 },
};

const responsiveCss = `
@media (max-width: 900px) {
  .cs-contact-layout { grid-template-columns: 1fr !important; }
}
`;

const banner = {
  bannerHeading: "Contact us",
  subheading:
    "Ask about a program, book a free assessment, or find your nearest campus.",
  path: [{ link: "/contact-us", name: "Contact us" }],
};

function ContactUs() {
  const location = useLocation();
  const [campuses, setCampuses] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  useEffect(() => {
    let alive = true;
    get_public_branches().then((rows) => alive && setCampuses(rows || []));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div style={{ background: "#fff" }}>
      <style>{responsiveCss}</style>
      <Header />
      <CommonBanner {...banner} />

      <main style={s.body}>
        <div style={s.container}>
          <div className="cs-contact-layout" style={s.layout}>
            <ContactForm
              eyebrow="Send us a message"
              heading="How can we help?"
              sub="Tell us your child's year level and what you are after. We will point you to the right program and campus."
            />

            <div style={s.side}>
              <div className="mq-card" style={s.panel}>
                <p style={s.panelTitle}>Head office</p>
                <p style={s.line}>{HEAD_OFFICE.address}</p>
                {HEAD_OFFICE.phones.map((p) => (
                  <p key={p} style={s.line}>
                    <a style={s.link} href={`tel:${p.replace(/\s/g, "")}`}>
                      {p}
                    </a>
                  </p>
                ))}
                <p style={s.line}>
                  <span style={s.strong}>Hours</span>
                  <br />
                  {HEAD_OFFICE.hours}
                </p>
              </div>

              {campuses.length > 0 && (
                <div className="mq-card" style={s.panel}>
                  <p style={s.panelTitle}>Our campuses</p>
                  {campuses.map((c, i) => (
                    <div
                      key={c.id || i}
                      style={i === 0 ? null : s.campus}
                    >
                      <p style={s.campusName}>
                        {c.name || c.branch_name || "Campus"}
                      </p>
                      <p style={s.campusMeta}>
                        {[c.region, c.state].filter(Boolean).join(", ")}
                        {c.phone ? ` · ${c.phone}` : ""}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ContactUs;
